// extracted by mini-css-extract-plugin
export var numpadContainer = "_nm-1";
export var phoneButton = "_nm-0";